import React from "react";
import { useAuth } from "../contexts/AuthContext";
import CampaignInsightsPage from "./CampaignInsightsPage";
import CampaignDetailPage from "./CampaignDetailPage";

function CampaignRouter() {
  const { userProfile } = useAuth();

  if (userProfile?.role === "publisher" || userProfile?.role === "admin") {
    return <CampaignInsightsPage />;
  }
  return <CampaignDetailPage />;
}

export default CampaignRouter;
